export var Global = {
     url: 'https://levelapp-lm.herokuapp.com/api/'
     // url: 'http://localhost:3700/api/'
}; 